export const HOME = {
  emergentLink: "home-emergent-link",
  ctaAdmin: "home-cta-admin",
  ctaCatalogPlaceholder: "home-cta-catalog-placeholder",
};

export const ADMIN = {
  root: "admin-root",
  greeting: "admin-greeting",
  orgSummary: "admin-org-summary",
  usersList: "admin-users-list",
};
